import { useGetPaginatedFilteredSuppliersQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { suppliersColumns, type SupplierRow, type SuppliersFilterInput } from '../constants/suppliersColumns';

export const SuppliersList = () => {
    const defaultFilters: SuppliersFilterInput = {
        shouldHideArchived: true,
    };

    const {
        loading: suppliersLoading,
        data: suppliersData,
        error: suppliersError,
        refetch,
        fetchMore,
    } = useGetPaginatedFilteredSuppliersQuery({
        variables: { offset: 0, shouldHideArchived: true },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    if (suppliersError) {
        throw new Error('Une erreur est survenue lors de la récupération des fournisseurs');
    }

    const hasMore = suppliersData?.paginatedFilteredSuppliers.hasMore ?? false;
    const suppliers = suppliersData?.paginatedFilteredSuppliers.suppliers ?? [];

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<SupplierRow, SuppliersFilterInput>
                columns={suppliersColumns}
                data={suppliers}
                filterMode="server"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/supplier/${row._id}`}
                hasMore={hasMore}
                isLoading={suppliersLoading}
                refetch={async (vars) => {
                    await refetch({
                        offset: 0,
                        filterString: vars.filters?.filterString,
                        shouldHideArchived: vars.filters?.shouldHideArchived,
                    });
                }}
                fetchMore={async (opts) => {
                    await fetchMore({
                        variables: {
                            offset: opts.variables.offset ?? suppliers.length,
                            filterString: opts.variables.filters?.filterString,
                            shouldHideArchived: opts.variables.filters?.shouldHideArchived,
                        },
                    });
                }}
                defaultFilters={defaultFilters}
                searchPlaceholder="Nom du fournisseur"
                searchFilterKey="filterString"
            />
        </div>
    );
};
